import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    minHeight: "100%",
    alignItems: "center",
    backgroundColor: "#EDF2F7",
    padding: theme.spacing(2),
  },
  tabContainer: {
    width: "100%",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    width: "100%",
    minHeight: "700px",
    padding: theme.spacing(4),
    gap: "8px",
    margin: 0,
    boxShadow: "none",
    borderRadius: 0,
    backgroundColor: "#FFF",
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px",
    },
  },

  listItem: {
    padding: theme.spacing(1.5, 0),
    "& h3": {
      cursor: "pointer",
      marginBottom: "20px",
    },
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(4),
  },
  logo: {
    width: 48,
    height: 48,
  },
  settingsList: {
    padding: 0,
  },

  backIcon: {
    width: 32,
    height: 32,
    cursor: "pointer",
  },

  communityHeading: {
    paddingTop: 0,
    fontFamily: "Istok Web",
    fontWeight: 700,
    fontSize: "20px",
    Lineheight: "23.03px",
    color: "#5C91FF",
  },


  pagetitle: {
    display: "flex",
    paddingLeft: '10px',
    alignItem: "center",
    "& h5": {
      fontSize: "25px",
      fontWeight: 700,
      color: "#5C91FF",
      fontFamily: "Istok Web",
    },
  },

  description: {
    cursor: "pointer",
    fontWeight: 400,
    fontFamily: 'Istok Web',
    fontSize: '20px',

  },
  toolbarContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#4A90E2", 
    padding: "10px 20px",
    borderRadius: "25px", 
    height: "47px",
    position: "relative",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    overflow: "hidden",
  },
  activeIconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#4A90E2",
    padding: "0px 20px",
    height: "100px",
    position: "relative",
    overflow: "hidden",
  },
  activeIcon: {
    position: "absolute",
    left: "13px",
    backgroundColor: "white",
    width: "calc(100% - 60px)",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
    borderRadius: "20px",
    marginTop: '-15px',
    "&:hover": {
      backgroundColor: "white",
    },
  },
  iconContainer: {
    display: "flex",
    justifyContent: 'space-around',
    width: "75%"
  },
  iconButton: {
    color: "white",
  },
  waveShape: {
    position: "relative",
    left: "-20px",
    top: "-21px",
    width: "200px",
    height: "112px",
    zIndex: 9999,
    background: "#4A90E2",
    clipPath: "polygon(100% 100%, 0% 100% , 0.00% 38.60%, 2.00% 38.52%, 4.00% 38.84%, 6.00% 39.54%, 8.00% 40.63%, 10.00% 42.07%, 12.00% 43.85%, 14.00% 45.95%, 16.00% 48.32%, 18.00% 50.92%, 20.00% 53.73%, 22.00% 56.69%, 24.00% 59.76%, 26.00% 62.89%, 28.00% 66.03%, 30.00% 69.12%, 32.00% 72.13%, 34.00% 75.00%, 36.00% 77.70%, 38.00% 80.16%, 40.00% 82.37%, 42.00% 84.27%, 44.00% 85.85%, 46.00% 87.08%, 48.00% 87.94%, 50.00% 88.40%, 52.00% 88.48%, 54.00% 88.16%, 56.00% 87.46%, 58.00% 86.37%, 60.00% 84.93%, 62.00% 83.15%, 64.00% 81.05%, 66.00% 78.68%, 68.00% 76.08%, 70.00% 73.27%, 72.00% 70.31%, 74.00% 67.24%, 76.00% 64.11%, 78.00% 60.97%, 80.00% 57.88%, 82.00% 54.87%, 84.00% 52.00%, 86.00% 49.30%, 88.00% 46.84%, 90.00% 44.63%, 92.00% 42.73%, 94.00% 41.15%, 96.00% 39.92%, 98.00% 39.06%, 100.00% 38.60%)",
  },
  galleryContainer: {
    marginTop: theme.spacing(2),
  },
  imageGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "16px",
    padding: "16px",
    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
  },
  galleryImage: {
    width: "100%",
    height: "250px",
    objectFit: "cover",
    borderRadius: theme.shape.borderRadius,
  },
  imageContainer: {
    position: "relative"
  },

  videoIconContainer: {
    position: "absolute",
    top: "10px",
    right: "10px"
  },
  inviteButton:{
    width:'120px',
    height:'40px',
    color:"#FFFFFF",
    borderRadius:'5px',
    backgroundColor:"#5C91FF",
    fontWeight: 400,
    fontSize:'14px',
    textTransform:'capitalize',
    "&:hover": {
      backgroundColor: "#5C91FF",
    },
    
  },
  memberListHeader:{
    display:'flex',
    justifyContent:'space-between',
    alignItem:'center'
  },
  searchInput: {
    backgroundColor: "#EDF2F7",
    borderRadius: 8,
    padding: theme.spacing(0, 2),
    height: "50px",
    display: "flex",
    flexGrow: 1,
    "& .MuiInputBase-root": {
      display: "flex",
      flexDirection: "row-reverse",
      alignItem: "center",
      justifyContent: "center",
    },
  },
  searchWrapper:{
    display: "flex",
    flexDirection: 'column',
    gap:"20px",
    marginTop:"10px"
  },
  memberListWrapper:{
    display: "flex",
    flexDirection: 'column',
    gap:"20px",
    marginTop:"50px"
  },
  table: {
    minWidth: 150,
  },
  userCell: {
    display: "flex",
    alignItems: "center",
  },
  // icon: {
  //   marginRight: 10,
  // },
  editIconWrapper:{
    backgroundColor: "#5C91FF",
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    width:'40px',
    height:'40px',
    borderRadius:'50%'
  },
  actionCell:{
    display:'flex',
    gap:'20px',
    justifyContent:'flex-start',
    alignItems:'center',
    marginTop:'12px'
  },
  inviteMember:{
    display:'flex',
    alignItems:'center'
  },
  inviteMemberTitle:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center'
  },
  inviteMemberHeading:{
    fontFamily:'Istok Web',
    fontWeight:700,
    fontSize:'30px',
    color: '#2158D0'
  },
  inviteMemberInfo:{
    fontFamily:'Istok Web',
    fontWeight:700,
    fontSize:'25px',
    color:'#000000'
  },
  inviteContainer: {
    display: "flex",
    justifyContent: "center",
    minHeight: '100vh',
    alignItems: "center",
    backgroundColor: "#EDF2F7",
    padding: theme.spacing(2),
  },
  inviteCard:{
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    maxWidth: '500px',
    padding: theme.spacing(4),
    gap: '8px',
    margin: 'auto',
    boxShadow:
        'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    borderRadius: theme.spacing(1),
    backgroundColor: '#FFF'
  },
  inviteForm:{
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginTop: theme.spacing(2.5),    
    '& .MuiOutlinedInput-root': {
        borderRadius: 6
    },
    '& .MuiFormLabel-root': {
        color: '#9794AA',
        marginBottom: theme.spacing(1),
    }
  },
  textField: {
    width: '100%',
    backgroundColor: '#F5F5F5',
    borderRadius: '10px'
  },
  formLabel: {
    color: "#2158D0",
    display: 'block',
    textAlign: 'left',
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '28.79px',
    fontFamily: 'Istok Web',
    marginTop: '0px',
    marginBottom: "-15px"
},
sendInviteButton:{
    width:'100%',
    height:'50px',
    color:"#FFFFFF",
    borderRadius:'5px',
    backgroundColor:"#5C91FF",
    fontWeight: 600,
    fontSize:'20px',
    textTransform:'capitalize',
    marginTop:'20px',
    "&:hover": {
      backgroundColor: "#5C91FF",
    },
 
    
},
inviteMemberinfoHeading:{
    display:'flex',
    marginTop:'30px'    
},
dividerContainer: {
  display: 'flex',
  alignItems: 'center',
  margin: `${theme.spacing(1)}px 0`,
  marginTop:'80px'
},
dividerLine: {
  flexGrow: 1,
  height: '1px',
  backgroundColor: theme.palette.divider,
},
dividerText: {
  margin: `0 ${theme.spacing(1)}px`,
  color: '#706C7C',
  fontWeight: 200,
  fontSize: 18
}
}));
